import styled from '@emotion/styled';
import { CONTENT_PRYMARY, CONTENT_PRYMARY_DARK } from 'constants/designSystem';
import React, { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from 'store/config';
import { contractService } from 'store/slices/contractSlice';

type Props = {};

const AirdropInfomation = (props: Props) => {
  const dispatch = useAppDispatch();
  const salesInfo = useAppSelector((state) => state.contract.salesInfo);
  const { maxSaleAmount, mintIndexForSale } = salesInfo;

  useEffect(() => {
    dispatch(contractService.connectContract());

    const reload = () => {
      window.location.reload();
    };

    window?.klaytn?.on('networkChanged', reload);

    return () => {
      window?.klaytn?.off('networkChanged', reload);
    };
  }, [dispatch]);

  return (
    <MintingInfoWrapper>
      <MintingInfoTitle>Airdrop Info</MintingInfoTitle>
      <SpaceBetween>
        <MintingInfoSubTitle>잔여 수량</MintingInfoSubTitle>
        <RemainingContent>
          <PrimaryContent>
            {(
              maxSaleAmount -
              (mintIndexForSale - (maxSaleAmount === 0 ? 0 : 1))
            ).toLocaleString() + ' '}
          </PrimaryContent>
          /<SecondContent>{' ' + maxSaleAmount.toLocaleString()}</SecondContent>
        </RemainingContent>
      </SpaceBetween>
      <RemainingProgress
        id='remaining-quantity'
        max={maxSaleAmount}
        value={maxSaleAmount - (mintIndexForSale - 1)}
      >
        {maxSaleAmount - (mintIndexForSale - 1)}
      </RemainingProgress>
      <SpaceBetween>
        <MintingInfoSubTitle>
          트랜잭션 당 최대 수량
          <PrimaryContent>{' MAX ' + 1}</PrimaryContent>
        </MintingInfoSubTitle>
        <MintingInfoSubTitle>
          지갑당
          <PrimaryContent>{' ' + 3}</PrimaryContent>
        </MintingInfoSubTitle>
      </SpaceBetween>
    </MintingInfoWrapper>
  );
};

const MintingInfoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const SpaceBetween = styled.div`
  display: flex;
  justify-content: space-between;
`;

const MintingInfoTitle = styled.p`
  font-weight: 900;
  margin-bottom: 8px;
`;

const MintingInfoSubTitle = styled.p`
  font-size: 16px;
  font-weight: 600;
  color: #5b5b5b;
`;

const RemainingContent = styled.p`
  font-size: 14px;
  color: #5b5b5b;
`;

const PrimaryContent = styled.span`
  font-weight: 900;
  color: ${CONTENT_PRYMARY};
`;

const SecondContent = styled.span`
  font-weight: 600;
  color: #939393;
`;

const RemainingProgress = styled.progress`
  width: 100%;
  appearance: none;

  &::-webkit-progress-bar {
    background: #f0f0f0;
    border-radius: 10px;
  }
  &::-webkit-progress-value {
    border-radius: 10px;
    background: ${CONTENT_PRYMARY_DARK};
    background: -webkit-linear-gradient(to right, #4d5ced, #f7aedc);
    background: linear-gradient(to right, #4d5ced, #f7aedc);
  }
`;

export default AirdropInfomation;
